<template>
  <section class="content-block">
    <transition name="slide-fade">
      <div
        v-if="active"
        class="block has-white-background"
      >
        <!-- PRODUCTS - START -->
        <div class="inner-block is-flex">
          <h3 class="title">
            {{ $t("anzahlView.label.ticketSelection") }}
          </h3>
          <br><br>
          <p class="subtitle">
            <b>{{ $t("anzahlView.label.ticketSelectionHint1") }}</b><br>
            {{ $t("anzahlView.label.ticketSelectionHint2") }}
          </p>
          <div
            v-for="(product, i) in this.$store.state.fetch_GET_Tickets"
            :key="'ticket-' + i"
            class="select-extended is-flex"
          >
            <div class="select">
              <select v-model="product.quantity">
                <option :value="0">
                  0
                </option>
                <option
                  v-for="index in $store.state.ticket_reservation_amount"
                  :disabled="index > (getRemainingTickets + product.quantity)"
                  :key="index"
                  :value="index"
                >
                  {{ index }}
                </option>
              </select>
            </div>

            <div class="select-info">
              <span class="title">{{ product.name }}</span>
              <p class="subtitle no-margin">
                {{ product.shortDescription }}
              </p>
            </div>
            <div class="select-pricing">
              <span class="title price-info">{{ formatPrice(product.price) }}</span>
              <p class="subtitle no-margin">
                {{ $t("general.label.taxInfo", {taxRate: 20}) }}
              </p>
            </div>
          </div>
        </div>
        <!-- PRODUCTS - END -->

        <!-- REMAINING AMOUNT - START -->
        <div class="select-extended-sum inner-block is-flex">
          <div class="col-2">
            <span class="title">
              {{ $t("anzahlView.label.remainingTickets", {remainingTickets: getRemainingTickets}) }}
            </span>
            <p class="subtitle no-margin">
              {{ $t("anzahlView.label.discountHint") }}
            </p>
          </div>
          <div class="col-2 align-right">
            <span class="title">{{ formatPrice(getTotalValue) }}</span>
            <p class="subtitle no-margin">
              {{ $t("general.label.taxInfo", {taxRate: 20}) }}
            </p>
          </div>
        </div>
        <!-- REMAINING AMOUNT - END -->

        <!-- ADDITIONAL MERCHANDIZE PRODUCTS - START -->
        <div
          v-for="(product, i) in this.$store.state.fetch_GET_additionalProducts"
          :key="'ticket-' + i"
          class="select-extended is-flex"
        >
          <div class="select">
            <select v-model="product.quantity">
              <option :value="0">
                0
              </option>
              <option
                v-for="index in $store.state.ticket_reservation_amount"
                :key="index"
                :value="index"
              >
                {{ index }}
              </option>
            </select>
          </div>

          <div class="select-info">
            <span class="title">{{ product.name }}</span>
            <p class="subtitle no-margin">
              {{ product.shortDescription }}
            </p>
          </div>
          <div class="select-pricing">
            <span class="title price-info">{{ formatPrice(product.price) }}</span>
            <p class="subtitle no-margin">
              {{ $t("general.label.taxInfo", {taxRate: 20}) }}
            </p>
          </div>
        </div>
        <!-- ADDITIONAL MERCHANDIZE PRODUCTS - END -->

        <!-- ICE PALACE - START -->
        <div
          class="inner-block"
          v-if="this.$store.state.selectedType !== '3'"
        >
          <hr>
          <div class="inner-block count">
            <input
              type="checkbox"
              class="checkbox"
              v-model="icepalaceAvailable"
              @change="fetch_GET_Tickets_Fn"
            >
            <p class="title">
              {{ $t("anzahlView.label.bookIcePalace") }}
            </p>
          </div>
          <div v-if="icepalaceAvailable">
            <p class="subtitle">
              {{ $t("anzahlView.label.icePalaceDescription") }}
            </p>
            <img
              src="../assets/eispalast-teaser-2024.jpg"
              alt="eispalast-teaser"
            >
            <p>© Harald Steiner</p>
          </div>
        </div>
        <!-- ICE PALACE - END -->
      </div>
    </transition>
  </section>
</template>

<script>
import {liveURL} from '../../api-config';
import axios from 'axios'

export default {
  name: 'Anzahl',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: false,
      icepalaceAvailable: true
    }
  },
  computed: {
    getRemainingTickets() {
      let remainingTickets = this.$store.state.fetch_GET_Tickets.reduce(
        (total, item) => total - item.quantity,
        this.$store.state.ticket_reservation_amount);

      // eslint-disable-next-line
      this.$store.state.unassignedTickets = remainingTickets;

      return remainingTickets;
    },
    getTotalValue() {
      let totalAmount = 0;
      this.$store.state.fetch_GET_Tickets.forEach(function (item) {
        totalAmount += parseFloat(item.price) * item.quantity;
      });
      this.$store.state.fetch_GET_additionalProducts.forEach(function (item) {
        totalAmount += parseFloat(item.price) * item.quantity;
      });

      return totalAmount;
    }
  },
  mounted() {
    this.active = true
    this.fetch_GET_Tickets_Fn()

    this.remainingTickets = this.$store.state.ticket_reservation_amount;

    // Eispalast ist für Talfahrten nicht verfügbar!
    if (this.$store.state.selectedType === '3') {
      this.icepalaceAvailable = false;
    }

    this.$store.state.purchase_process = true;
  },
  methods: {
    fetch_GET_Tickets_Fn() {
      const url = liveURL + `/api/eventReservation/frontend/products/${this.$store.state.reservationNr}`;
      axios.get(url, {}).then(function (response) {
        if (this.icepalaceAvailable) {
          response.data = response.data.filter(product => {
            return (product.name.indexOf('Eispalast') !== -1
              || (product.name.indexOf('Icepalace')) !== -1
              || (product.name.indexOf('Ice palace')) !== -1
              || (product.name.indexOf('Hund')) !== -1
              || (product.name.indexOf('Dog')) !== -1);
          });
        } else {
          response.data = response.data.filter(product => {
            return (product.name.indexOf('Eispalast') === -1
              && (product.name.indexOf('Icepalace')) === -1
              && (product.name.indexOf('Ice palace')) === -1);
          });
        }
        this.$store.state.fetch_GET_Tickets = response.data.filter((e) => !e.attributes.includes('additionalProduct'));
        this.$store.state.fetch_GET_additionalProducts = response.data.filter((e) => e.attributes.includes('additionalProduct'));
      }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return '€ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-extended {
  width: 100%;
  display: block;
  position: relative;
  margin-top: 0.9rem;

  .select-info,
  .select-pricing {
    padding-top: 0.42rem;
    padding-left: 0.6rem;
  }

  .select-pricing {
    text-align: right;
    margin-left: auto;
    display: block;
    min-width: 65px;
  }

  .title {
    text-transform: none;
    margin-bottom: 0rem;
  }
}

.select-extended-sum {
  border-top: 1px solid rgb(200, 200, 200);
  padding-top: 1.2rem;
  margin-top: 0rem;

  .title {
    text-transform: none;
    margin-bottom: 0rem;
  }
}

.price-info {
  cursor: pointer;
}

button control has-icons-right is-primary
.no-margin {
  margin-bottom: 0 !important;
}

.align-right {
  text-align: right;
}

.inner-block.count {
  display: flex;
  /*justify-content: flex-end;*/
  align-items: center;
}

.inner-block.count .title {
  margin-bottom: 0;
  margin-right: 1em;
  margin-left: 1em;
}
</style>
